<template>
  <div class="py-4 space-y-8">
    <!-- Titre principal -->
    <div class="text-center mb-8">
      <h1 class="text-xl font-bold text-foreground mb-3">
        {{ $t('hhi.info.title') }}
      </h1>
      <p class="text-base text-muted-foreground leading-relaxed max-w-sm mx-auto">
        {{ $t('hhi.info.description') }}
      </p>
    </div>

    <!-- Section des seuils -->
    <div class="space-y-6">
      <h2 class="text-lg font-semibold text-foreground mb-4">
        {{ $t('hhi.info.interpretation') }}
      </h2>
      
      <!-- Excellent -->
      <div class="space-y-3">
        <div class="flex items-center gap-3">
          <div class="w-3 h-3 rounded-full bg-green-500"></div>
          <h3 class="text-base font-semibold text-foreground">{{ $t('hhi.info.levels.excellent.title') }}</h3>
          <span class="text-sm text-muted-foreground/70 font-medium">{{ $t('hhi.info.levels.excellent.range') }}</span>
        </div>
        <p class="text-muted-foreground leading-relaxed ml-6">
          {{ $t('hhi.info.levels.excellent.description') }}
        </p>
      </div>

      <!-- Bon -->
      <div class="space-y-3">
        <div class="flex items-center gap-3">
          <div class="w-3 h-3 rounded-full bg-blue-500"></div>
          <h3 class="text-base font-semibold text-foreground">{{ $t('hhi.info.levels.good.title') }}</h3>
          <span class="text-sm text-muted-foreground/70 font-medium">{{ $t('hhi.info.levels.good.range') }}</span>
        </div>
        <p class="text-muted-foreground leading-relaxed ml-6">
          {{ $t('hhi.info.levels.good.description') }}
        </p>
      </div>

      <!-- Moyen -->
      <div class="space-y-3">
        <div class="flex items-center gap-3">
          <div class="w-3 h-3 rounded-full bg-yellow-500"></div>
          <h3 class="text-base font-semibold text-foreground">{{ $t('hhi.info.levels.average.title') }}</h3>
          <span class="text-sm text-muted-foreground/70 font-medium">{{ $t('hhi.info.levels.average.range') }}</span>
        </div>
        <p class="text-muted-foreground leading-relaxed ml-6">
          {{ $t('hhi.info.levels.average.description') }}
        </p>
      </div>

      <!-- Médiocre -->
      <div class="space-y-3">
        <div class="flex items-center gap-3">
          <div class="w-3 h-3 rounded-full bg-red-500"></div>
          <h3 class="text-base font-semibold text-foreground">{{ $t('hhi.info.levels.bad.title') }}</h3>
          <span class="text-sm text-muted-foreground/70 font-medium">{{ $t('hhi.info.levels.bad.range') }}</span>
        </div>
        <p class="text-muted-foreground leading-relaxed ml-6">
          {{ $t('hhi.info.levels.bad.description') }}
        </p>
      </div>

      <!-- Mauvais -->
      <div class="space-y-3">
        <div class="flex items-center gap-3">
          <div class="w-3 h-3 rounded-full bg-red-700"></div>
          <h3 class="text-base font-semibold text-foreground">{{ $t('hhi.info.levels.poor.title') }}</h3>
          <span class="text-sm text-muted-foreground/70 font-medium">{{ $t('hhi.info.levels.poor.range') }}</span>
        </div>
        <p class="text-muted-foreground leading-relaxed ml-6">
          {{ $t('hhi.info.levels.poor.description') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Component logic here if needed
</script>